// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamPlayersPage__header {
  max-width: 1400px;
  margin: 22px 0 16px;
  padding: 0 15px;
}
.teamPlayersPage__breadcrumb {
  margin-bottom: 9px;
  color: #69778a;
  font-size: 12px;
}
.teamPlayersPage__breadcrumb span {
  padding: 0 5px;
  color: #a3afbd;
}
.teamPlayersPage__titleRow {
  display: flex;
  align-items: center;
  gap: 12px;
}
.teamPlayersPage__titleRow h1 {
  margin: 0;
  color: #142033;
  font-size: 24px;
  font-weight: 800;
}
.teamPlayersPage__titleRow p {
  margin: 3px 0 0;
  color: #69778a;
  font-size: 13px;
}
.teamPlayersPage__back {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d3dce6;
  border-radius: 9px;
  background: #fff;
  color: #334155;
  font-size: 18px;
}
.teamPlayersPage__changes {
  margin-left: auto;
  padding: 5px 10px;
  border-radius: 999px;
  background: #fff7e8;
  color: #966317;
  font-size: 11px;
  font-weight: 700;
}
.teamPlayersPage__footer {
  position: sticky;
  z-index: 10;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 14px;
  padding: 14px 20px;
  border-top: 1px solid #dbe3ec;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.06);
}
.teamPlayersPage__cancel,
.teamPlayersPage__save {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
.teamPlayersPage__cancel {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.teamPlayersPage__save {
  border: 1px solid #227ebd;
  background: #227ebd;
  color: #fff;
}
.teamPlayersPage__save:disabled {
  border-color: #cbd5e1;
  background: #e7edf3;
  color: #94a3b8;
}
.teamPlayersPage__header + .twoPanelEditor {
  max-width: 1400px;
  margin-right: 0;
  margin-left: 0;
  --accent: #227ebd;
  --accent-hover: #155d8c;
  --row-selected: #eaf4fb;
  --row-selected-border: #227ebd;
}
.teamPlayersPage__header + .twoPanelEditor .twoPanelEditor__panelCol--left,
.teamPlayersPage__header + .twoPanelEditor .twoPanelEditor__panelCol--right {
  flex: 1 1 0;
  max-width: calc(50% - 28px);
}
@media (max-width: 767px) {
  .teamPlayersPage__changes {
    display: none;
  }
  .teamPlayersPage__header {
    margin-top: 14px;
  }
  .teamPlayersPage__footer {
    padding: 12px 15px;
  }
  .teamPlayersPage__footer button {
    flex: 1;
  }
}
.teamPlayersWarningModal {
  max-width: 500px !important;
}
.teamPlayersWarning {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: 14px;
}
.teamPlayersWarning__icon {
  display: flex;
  width: 46px;
  height: 46px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff3df;
  color: #a96709;
  font-size: 22px;
  font-weight: 800;
}
.teamPlayersWarning__copy strong {
  color: #142033;
  font-size: 14px;
}
.teamPlayersWarning__copy p {
  margin: 6px 0 0;
  color: #69778a;
  font-size: 13px;
  line-height: 1.5;
}
.teamPlayersWarning__actions {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 10px;
  padding-top: 16px;
  border-top: 1px solid #e5eaf0;
}
.teamPlayersWarning__discard {
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid #c9364b;
  border-radius: 9px;
  background: #c9364b;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.teamPlayersWarning--result {
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
}
.teamPlayersWarning--result .teamPlayersWarning__copy {
  min-width: 0;
}
.teamPlayersWarning--result .teamPlayersWarning__copy strong {
  display: block;
  font-size: 16px;
  line-height: 1.5;
}
.teamPlayersWarning--result .teamPlayersWarning__actions {
  margin-top: 20px;
}
.teamPlayersPage__sportRoster {
  max-width: 1440px;
  margin: 20px 15px 28px;
  padding: 26px;
  border: 1px solid #dbe5ef;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(32, 57, 85, 0.07);
}
.teamPlayersPage__assignmentIntro {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
}
.teamPlayersPage__assignmentIntro span {
  color: #227ebd;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.teamPlayersPage__assignmentIntro h2 {
  margin: 4px 0;
  color: #142033;
  font-size: 22px;
  font-weight: 800;
}
.teamPlayersPage__assignmentIntro p {
  margin: 0;
  color: #69778a;
  font-size: 13px;
}
.teamPlayersPage__assignmentIntro > strong {
  padding: 7px 11px;
  border-radius: 999px;
  background: #eef6fc;
  color: #155d8c;
  font-size: 12px;
  white-space: nowrap;
}
.teamPlayersPage__sportSections {
  display: grid;
  gap: 18px;
  margin-top: 22px;
}
.teamPlayersPage__sportSection {
  overflow: hidden;
  border: 1px solid #dbe5ef;
  border-radius: 14px;
  background: #f8fbfe;
}
.teamPlayersPage__sportSectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #dbe5ef;
  background: #eef6fc;
}
.teamPlayersPage__sportSectionHead span {
  color: #227ebd;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.teamPlayersPage__sportSectionHead h3 {
  margin: 2px 0 0;
  color: #17324d;
  font-size: 17px;
  font-weight: 800;
}
.teamPlayersPage__sportSectionHead > strong {
  padding: 5px 9px;
  border-radius: 999px;
  background: #fff;
  color: #52677d;
  font-size: 11px;
  white-space: nowrap;
}
.teamPlayersPage__sportPlayers {
  padding: 4px 10px 12px;
}
.teamPlayersPage__sportPlayer {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(150px, 210px) auto;
  gap: 10px;
  align-items: center;
  margin-top: 8px;
  padding: 10px 12px;
  border: 1px solid #e3e9f0;
  border-radius: 11px;
  background: #fff;
  transition: border-color 0.15s, background 0.15s;
}
.teamPlayersPage__sportPlayer.is-included {
  border-color: #cfe0ef;
  background: #fbfdff;
}
.teamPlayersPage__sportPlayer.is-excluded {
  background: #f8fafc;
  color: #8793a2;
}
.teamPlayersPage__sportPlayer label {
  display: flex;
  gap: 9px;
  align-items: center;
  margin: 0;
}
.teamPlayersPage__playerIdentity > input {
  width: 17px;
  height: 17px;
  accent-color: #227ebd;
}
.teamPlayersPage__playerIdentity > i {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #e8f2fa;
  color: #155d8c;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}
.teamPlayersPage__playerIdentity > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.teamPlayersPage__playerIdentity strong {
  color: #26384d;
  font-size: 14px;
}
.teamPlayersPage__playerIdentity small {
  margin-top: 2px;
  color: #7a8797;
  font-size: 11px;
}
.teamPlayersPage__position {
  min-width: 0;
  align-items: stretch !important;
  gap: 4px !important;
}
.teamPlayersPage__position > span {
  color: #69778a;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.teamPlayersPage__sportPlayer select {
  width: 100%;
  min-height: 34px;
  padding: 0 9px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
}
.teamPlayersPage__sportFlags {
  display: inline-flex;
  justify-self: end;
  gap: 3px;
  padding: 2px;
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  background: #f8fafc;
}
.teamPlayersPage__sportFlag {
  position: relative;
  margin: 0;
  cursor: pointer;
}
.teamPlayersPage__sportFlag input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.teamPlayersPage__sportFlag span {
  display: inline-flex;
  min-width: 27px;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 6px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}
.teamPlayersPage__sportFlag input:checked + span {
  background: #227ebd;
  color: #fff;
}
.teamPlayersPage__sportFlag input:disabled + span {
  cursor: not-allowed;
  opacity: 0.45;
}
@media (max-width: 850px) {
  .teamPlayersPage__sportPlayer {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 600px) {
  .teamPlayersPage__sportRoster {
    margin: 12px 10px;
    padding: 17px;
  }
  .teamPlayersPage__assignmentIntro {
    flex-direction: column;
  }
  .teamPlayersPage__sportSectionHead {
    align-items: flex-start;
    flex-direction: column;
  }
  .teamPlayersPage__sportPlayer {
    grid-template-columns: 1fr;
  }
}
.teamPlayersPage__syncOption {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 18px;
  padding: 16px 18px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  cursor: pointer;
}
.teamPlayersPage__syncOption input {
  margin-top: 3px;
  accent-color: var(--blue-600, #227ebd);
}
.teamPlayersPage__syncOption strong {
  display: block;
  font-size: 13px;
  color: var(--text-strong, #142033);
}
.teamPlayersPage__syncOption small {
  display: block;
  margin-top: 5px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  line-height: 1.5;
}
.teamPlayersPage__syncError {
  margin-top: 16px;
  padding: 14px 18px;
  color: #a32e38;
  border: 1px solid #f4c8cf;
  border-radius: 10px;
  background: #fff4f5;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/TeamsAndEvents/Teams/SchoolTeamPlayers.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,8CAA8C;AAChD;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,OAAO;EACT;AACF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,MAAM;AACR;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".teamPlayersPage__header {\n  max-width: 1400px;\n  margin: 22px 0 16px;\n  padding: 0 15px;\n}\n.teamPlayersPage__breadcrumb {\n  margin-bottom: 9px;\n  color: #69778a;\n  font-size: 12px;\n}\n.teamPlayersPage__breadcrumb span {\n  padding: 0 5px;\n  color: #a3afbd;\n}\n.teamPlayersPage__titleRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.teamPlayersPage__titleRow h1 {\n  margin: 0;\n  color: #142033;\n  font-size: 24px;\n  font-weight: 800;\n}\n.teamPlayersPage__titleRow p {\n  margin: 3px 0 0;\n  color: #69778a;\n  font-size: 13px;\n}\n.teamPlayersPage__back {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d3dce6;\n  border-radius: 9px;\n  background: #fff;\n  color: #334155;\n  font-size: 18px;\n}\n.teamPlayersPage__changes {\n  margin-left: auto;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: #fff7e8;\n  color: #966317;\n  font-size: 11px;\n  font-weight: 700;\n}\n.teamPlayersPage__footer {\n  position: sticky;\n  z-index: 10;\n  bottom: 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 14px;\n  padding: 14px 20px;\n  border-top: 1px solid #dbe3ec;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.06);\n}\n.teamPlayersPage__cancel,\n.teamPlayersPage__save {\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamPlayersPage__cancel {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.teamPlayersPage__save {\n  border: 1px solid #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.teamPlayersPage__save:disabled {\n  border-color: #cbd5e1;\n  background: #e7edf3;\n  color: #94a3b8;\n}\n.teamPlayersPage__header + .twoPanelEditor {\n  max-width: 1400px;\n  margin-right: 0;\n  margin-left: 0;\n  --accent: #227ebd;\n  --accent-hover: #155d8c;\n  --row-selected: #eaf4fb;\n  --row-selected-border: #227ebd;\n}\n.teamPlayersPage__header + .twoPanelEditor .twoPanelEditor__panelCol--left,\n.teamPlayersPage__header + .twoPanelEditor .twoPanelEditor__panelCol--right {\n  flex: 1 1 0;\n  max-width: calc(50% - 28px);\n}\n@media (max-width: 767px) {\n  .teamPlayersPage__changes {\n    display: none;\n  }\n  .teamPlayersPage__header {\n    margin-top: 14px;\n  }\n  .teamPlayersPage__footer {\n    padding: 12px 15px;\n  }\n  .teamPlayersPage__footer button {\n    flex: 1;\n  }\n}\n.teamPlayersWarningModal {\n  max-width: 500px !important;\n}\n.teamPlayersWarning {\n  display: grid;\n  grid-template-columns: 48px 1fr;\n  gap: 14px;\n}\n.teamPlayersWarning__icon {\n  display: flex;\n  width: 46px;\n  height: 46px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #fff3df;\n  color: #a96709;\n  font-size: 22px;\n  font-weight: 800;\n}\n.teamPlayersWarning__copy strong {\n  color: #142033;\n  font-size: 14px;\n}\n.teamPlayersWarning__copy p {\n  margin: 6px 0 0;\n  color: #69778a;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.teamPlayersWarning__actions {\n  grid-column: 1/-1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 10px;\n  padding-top: 16px;\n  border-top: 1px solid #e5eaf0;\n}\n.teamPlayersWarning__discard {\n  min-height: 40px;\n  padding: 0 16px;\n  border: 1px solid #c9364b;\n  border-radius: 9px;\n  background: #c9364b;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n}\n.teamPlayersWarning--result {\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0;\n}\n.teamPlayersWarning--result .teamPlayersWarning__copy {\n  min-width: 0;\n}\n.teamPlayersWarning--result .teamPlayersWarning__copy strong {\n  display: block;\n  font-size: 16px;\n  line-height: 1.5;\n}\n.teamPlayersWarning--result .teamPlayersWarning__actions {\n  margin-top: 20px;\n}\n.teamPlayersPage__sportRoster {\n  max-width: 1440px;\n  margin: 20px 15px 28px;\n  padding: 26px;\n  border: 1px solid #dbe5ef;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 12px 32px rgba(32, 57, 85, 0.07);\n}\n.teamPlayersPage__assignmentIntro {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  align-items: flex-start;\n}\n.teamPlayersPage__assignmentIntro span {\n  color: #227ebd;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n.teamPlayersPage__assignmentIntro h2 {\n  margin: 4px 0;\n  color: #142033;\n  font-size: 22px;\n  font-weight: 800;\n}\n.teamPlayersPage__assignmentIntro p {\n  margin: 0;\n  color: #69778a;\n  font-size: 13px;\n}\n.teamPlayersPage__assignmentIntro > strong {\n  padding: 7px 11px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #155d8c;\n  font-size: 12px;\n  white-space: nowrap;\n}\n.teamPlayersPage__sportSections {\n  display: grid;\n  gap: 18px;\n  margin-top: 22px;\n}\n.teamPlayersPage__sportSection {\n  overflow: hidden;\n  border: 1px solid #dbe5ef;\n  border-radius: 14px;\n  background: #f8fbfe;\n}\n.teamPlayersPage__sportSectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #dbe5ef;\n  background: #eef6fc;\n}\n.teamPlayersPage__sportSectionHead span {\n  color: #227ebd;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.teamPlayersPage__sportSectionHead h3 {\n  margin: 2px 0 0;\n  color: #17324d;\n  font-size: 17px;\n  font-weight: 800;\n}\n.teamPlayersPage__sportSectionHead > strong {\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #fff;\n  color: #52677d;\n  font-size: 11px;\n  white-space: nowrap;\n}\n.teamPlayersPage__sportPlayers {\n  padding: 4px 10px 12px;\n}\n.teamPlayersPage__sportPlayer {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(150px, 210px) auto;\n  gap: 10px;\n  align-items: center;\n  margin-top: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e3e9f0;\n  border-radius: 11px;\n  background: #fff;\n  transition: border-color 0.15s, background 0.15s;\n}\n.teamPlayersPage__sportPlayer.is-included {\n  border-color: #cfe0ef;\n  background: #fbfdff;\n}\n.teamPlayersPage__sportPlayer.is-excluded {\n  background: #f8fafc;\n  color: #8793a2;\n}\n.teamPlayersPage__sportPlayer label {\n  display: flex;\n  gap: 9px;\n  align-items: center;\n  margin: 0;\n}\n.teamPlayersPage__playerIdentity > input {\n  width: 17px;\n  height: 17px;\n  accent-color: #227ebd;\n}\n.teamPlayersPage__playerIdentity > i {\n  display: flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 11px;\n  background: #e8f2fa;\n  color: #155d8c;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 800;\n}\n.teamPlayersPage__playerIdentity > span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n.teamPlayersPage__playerIdentity strong {\n  color: #26384d;\n  font-size: 14px;\n}\n.teamPlayersPage__playerIdentity small {\n  margin-top: 2px;\n  color: #7a8797;\n  font-size: 11px;\n}\n.teamPlayersPage__position {\n  min-width: 0;\n  align-items: stretch !important;\n  gap: 4px !important;\n}\n.teamPlayersPage__position > span {\n  color: #69778a;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.teamPlayersPage__sportPlayer select {\n  width: 100%;\n  min-height: 34px;\n  padding: 0 9px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n}\n.teamPlayersPage__sportFlags {\n  display: inline-flex;\n  justify-self: end;\n  gap: 3px;\n  padding: 2px;\n  border: 1px solid #dbe3ec;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n.teamPlayersPage__sportFlag {\n  position: relative;\n  margin: 0;\n  cursor: pointer;\n}\n.teamPlayersPage__sportFlag input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n.teamPlayersPage__sportFlag span {\n  display: inline-flex;\n  min-width: 27px;\n  height: 26px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 6px;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n}\n.teamPlayersPage__sportFlag input:checked + span {\n  background: #227ebd;\n  color: #fff;\n}\n.teamPlayersPage__sportFlag input:disabled + span {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n@media (max-width: 850px) {\n  .teamPlayersPage__sportPlayer {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .teamPlayersPage__sportRoster {\n    margin: 12px 10px;\n    padding: 17px;\n  }\n  .teamPlayersPage__assignmentIntro {\n    flex-direction: column;\n  }\n  .teamPlayersPage__sportSectionHead {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .teamPlayersPage__sportPlayer {\n    grid-template-columns: 1fr;\n  }\n}\n.teamPlayersPage__syncOption {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 0 18px;\n  padding: 16px 18px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  cursor: pointer;\n}\n.teamPlayersPage__syncOption input {\n  margin-top: 3px;\n  accent-color: var(--blue-600, #227ebd);\n}\n.teamPlayersPage__syncOption strong {\n  display: block;\n  font-size: 13px;\n  color: var(--text-strong, #142033);\n}\n.teamPlayersPage__syncOption small {\n  display: block;\n  margin-top: 5px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  line-height: 1.5;\n}\n.teamPlayersPage__syncError {\n  margin-top: 16px;\n  padding: 14px 18px;\n  color: #a32e38;\n  border: 1px solid #f4c8cf;\n  border-radius: 10px;\n  background: #fff4f5;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
